




















































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import * as Y from 'yjs'
import { bytesToBase64 } from 'byte-base64'
import SlidePreviewTail from 'components/presenter/item/topic/viewer/PreviewTail.vue'

@Component({
  components: {
    SlidePreviewTail
  }
})
export default class ItemTopicSlidesEditorCreateButtons extends Vue {
  clipboard: Json[] = []

  @Prop()
  readonly nextSlideSort!: number

  @Prop({ default: false })
  readonly pasteOff!: boolean

  created () {
    this.clipboard = this.$q.localStorage.getItem('SlideClipboard') || [] as Json[]
    for (const group of this.clipboard) {
      for (const slide of group.slides || [] as Json) {
        if (slide.text) {
          slide.text = this.createYDocText(slide.text[''] || '')
        }
        if (slide.notes) {
          slide.notes = this.createYDocText(slide.notes[''] || '')
        }
        if (slide.gaps) {
          slide.gaps = this.createYDocText(slide.gaps[''] || '')
        }
        for (const answer of Object.values(slide.answers || {}) as Json[]) {
          answer.text = this.createYDocText(answer.text ? answer.text[''] : '')
        }
      }
    }
  }

  createYDocText (text: string) {
    const doc = new Y.Doc()
    doc.getText().insert(0, text)
    return doc
  }

  clear (groupIndex: number) {
    this.clipboard.splice(groupIndex, 1)
    this.$q.localStorage.set('SlideClipboard', this.clipboard)
  }

  pasteAll(group: Json) {
    const data = { slidesCorrects: {}, slidesSettings: {}, slidesTexts: {} }
    const files = new Set<string>()
    let newSlideId = new Date().getTime()
    let newSlideSort = this.nextSlideSort
    for (const slide of group.slides) {
      if (slide.type === 'Params') {
        this.setRequestData(slide.id, 0, slide, data, files)
      } else {
        this.setRequestData((newSlideId++).toString(), newSlideSort++, slide, data, files)
      }
    }
    this.$emit('paste', { data, files: [...files] })
  }

  paste (slide: Json, group: Json) {
    const data = { slidesCorrects: {}, slidesSettings: {}, slidesTexts: {} }
    const files = new Set<string>()
    const newSlideId = new Date().getTime().toString()
    this.setRequestData(newSlideId, this.nextSlideSort, slide, data, files)
    if (slide.params) {
      const params = group.slides.filter((s: Json) => s.id === slide.params).pop()
      if (params) {
        this.setRequestData(params.id, 0, params, data, files)
      }
    }
    this.$emit('paste', { data, files: [...files] })
  }

  setRequestData (newSlideId: string, newSlideSort: number, slide: Json, data: Json, files: Set<string>) {
    for (const key in slide) {
      const value = slide[ key ]
      if (key === 'id') {
        data.slidesSettings[`${newSlideId}:${key}`] = newSlideId
      } else if (key === 'sort') {
        data.slidesSettings[`${newSlideId}:${key}`] = newSlideSort
      } else if (key === 'correct') {
        data.slidesCorrects[`${newSlideId}`] = value
      } else if (key === 'answers') {
        for (const answer of Object.values(slide.answers) as Json[]) {
          for (const akey in answer) {
            const avalue = answer[ akey ]
            if (avalue instanceof Y.Doc) {
              const update = Y.encodeStateAsUpdate(avalue)
              data.slidesTexts[`${newSlideId}:answers:${answer.id}:${akey}`] = [ bytesToBase64(update) ]
              this.setTextImages(avalue, files)
            } else if (avalue) {
              data.slidesSettings[`${newSlideId}:answers:${answer.id}:${akey}`] = avalue
            }
          }
        }
      } else if (key === 'src') {
        const src = value.toString().trim()
        data.slidesSettings[`${newSlideId}:${key}`] = value
        if (src.startsWith('/')) {
          files.add(src)
        }
      } else if (key === 'pageNo') {
        data.slidesSettings[`${newSlideId}:meta`] = { pages: [{ pageNo: value, sort: newSlideSort }] }
      } else if (['shuffle', 'timer', 'group', 'hide', 'deleted', 'meta'].includes(key)) {
        continue
      } else if (value instanceof Y.Doc) {
        const update = Y.encodeStateAsUpdate(value)
        data.slidesTexts[`${newSlideId}:${key}`] = [ bytesToBase64(update) ]
        this.setTextImages(value, files)
      } else if (value) {
        data.slidesSettings[`${newSlideId}:${key}`] = value
      }
    }
  }

  setTextImages(doc: Y.Doc, files: Set<string>) {
    const text = doc.getText().toString()
    // @ts-ignore
    const links = [...text.matchAll(/\[.*\]\((.+)\)/g)]
    for (const path of links) {
      if (path.length > 1) {
        const src = path[1].trim()
        if (src.startsWith('/')) {
          files.add(src)
        }
      }
    }
  }
}
